/**
 * Whether a profile belongs to the identity that produced the current token.
 *
 * The uid is the only thing that answers this. Matching on the address as well used to be
 * the second half of the check, mirroring the backend lookup EPIC-004 removed: the address
 * is free in the shared Firebase pool whenever the row's identity was never created there,
 * so anyone who minted an account holding it would have been read as that person. It also
 * accepted a profile whose `id` had drifted from the uid, which is the divergence the whole
 * identity contract exists to prevent.
 *
 * Plain function on purpose — no React, no Firebase, no navigation. See EPIC-005.
 */
export type IdentifiedProfile = { id?: string | null } | null | undefined

export function profileBelongsToIdentity(profile: IdentifiedProfile, uid: string | null | undefined): boolean {
  if (!profile?.id || !uid) return false

  return String(profile.id) === String(uid)
}
